/** PUT a file to a GCS v4 signed URL (only signed headers — no axios extras). */
export const uploadFileToSignedUrl = async (uploadUrl: string, file: File, contentType: string) => {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': contentType,
      'x-goog-acl': 'public-read',
    },
  })

  if (!response.ok) {
    const detail = await response.text().catch(() => '')
    throw new Error(detail || `Upload failed (${response.status})`)
  }
}

/** storage.googleapis.com is the stable public URL host (matches clinic uploads). */
export const normalizeGcsPublicUrl = (url: string) =>
  url.replace('https://storage.cloud.google.com/', 'https://storage.googleapis.com/')
